import Config = require("../config");
import * as Cookies from "js-cookie";
import * as $ from "jquery";
import { ConfigService } from "./ConfigService";
import { IAuthenticateResult } from "../models";
import { handleError } from "./ErrorHandling";

export class AuthService {
    public readonly IdentityCookieKey: string =
        "Plumsail.HelpDesk.Widget.IdentityToken";
    public static readonly CaptchaSiteKey: string =
        "6LcD5vMUAAAAAFRa5sNQJ07U0kBBPP0SPMO1qdtb";
    public static isOnSPSite: boolean = false;

    private static readonly _productId: string =
        "a3378983-351e-4b0c-a4c2-7095e08b6c39";

    constructor(private readonly _configService: ConfigService) {
        let context = this._configService.SPPageContext;
        if (context){
                    AuthService.isOnSPSite=true;
            }
        let userId = context ? context.userId : "";
        this.IdentityCookieKey = `Plumsail.HelpDesk.Widget.Token${this._configService.CookieSuffix}|${userId}`;
    }

    
    public get IdentityToken() {
        const cookie = Cookies.get(this.IdentityCookieKey);
        let obj = null;
        try {
            obj = JSON.parse(cookie);
        } catch {}
        return obj && obj.token ? obj.token : "";
    }

    public get IdentityUser() {
        const cookie = Cookies.get(this.IdentityCookieKey);
        let obj = null;
        let username = '';
        try {
            obj = JSON.parse(cookie);
            const token = obj.token;
            const data = new Buffer(token, 'base64').toString();
            const regex = /"UserIdentity":"([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)"/;
            const searchRes = regex.exec(data);
            if (searchRes.length > 0) {
                const userIdentityStr = searchRes[0];
                const splittedUserIdentity = userIdentityStr.split(':');
                if (splittedUserIdentity.length > 1)
                    username = splittedUserIdentity[1].replace(/"/g, '').trim();
            }
        } catch (e) {
            console.error(e);
        }
        return username;
    }

    private _getContextToken = () => {
        return new Promise<string>((resolve, reject) => {
            SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
                var clientContext = new SP.ClientContext(
                    this._configService.SPPageContext.webAbsoluteUrl
                );
                var currentWeb = clientContext.get_web();
                var appInstances = SP.AppCatalog.getAppInstances(
                    clientContext,
                    currentWeb
                );
                clientContext.load(appInstances);
                clientContext.load(currentWeb);
                clientContext.executeQueryAsync(
                    () => {
                        var app = appInstances
                            .get_data()
                            .filter(
                                (x: any) =>
                                    x.get_productId().ToSerialized() ===
                                    AuthService._productId
                            )
                            .pop();
                        if (app) {
                            const appId = app.get_id();
                            const currentWebUrl = currentWeb.get_url();
                            const redirectUrl = `${currentWebUrl}/_layouts/15/appredirect.aspx?instance_Id={${appId}}`;
                            $.get(redirectUrl).then(
                                (redirectResponse: string) => {
                                    var form =
                                        $(redirectResponse).filter(
                                            "#frmRedirect"
                                        );
                                    var contextToken = form
                                        .find("input[name=SPAppToken]")
                                        .val();
                                    resolve(contextToken);
                                },
                                xhr => reject("Redirect get failed")
                            );
                        } else {
                            reject(new Error("Widget App is not installed"));
                        }
                    },
                    (sender, args) => reject(args)
                );
            });
        });
    };

    private _getGraphApiToken = () => {
        return new Promise<string>((resolve, reject) => {
            if(
                window['Plumsail'] &&
                window['Plumsail']['HelpDesk'] &&
                window['Plumsail']['HelpDesk']['WidgetToken']
            ) {
                (window as any).Plumsail.HelpDesk.WidgetToken
                    .then(token => {
                        token ? resolve(token) : reject();
                    })
                    .catch(() => reject())
            } else {
                reject();
            }
        });
    }

    private _getAuthToken = () => {
        return new Promise<IAuthenticateResult>((resolve, reject) => {
            const resolveHash = (hash: string) => {
                var expires = new Date();
                expires.setHours(expires.getHours() + 1);
                var result: IAuthenticateResult = {
                    Jwt: hash,
                    ExpiresOn: expires
                };
                resolve(result);
            };
            const authRequest = (endpoint: string, token: string) => {
                const requestParams = {
                    ContextToken: token,                    
                    WebUrl: this._configService.SPPageContext.webAbsoluteUrl
                };
                return new Promise(async (resolve, reject) => {
                    $.ajax({
                        type: "POST",
                        url: endpoint,
                        data: JSON.stringify(requestParams),
                        contentType: "application/json",
                        success: response => resolve(response),
                        error: xhr => handleError(xhr, reject)
                    });            
                });
            }
            const tryAppAuth = () => {
                this._getContextToken()
                    .then(async contextToken => {
                        authRequest(
                            `${this._configService.ApiUrl}/${this._configService.ConfigCode}/spauth`,
                            contextToken
                        ).then(
                            (hash: string) => resolveHash(hash),
                            xhr => {
                                if (xhr.status === 401) {
                                    let error = new Error(xhr.responseText);
                                    error.name = "crosstenant";
                                    reject(error);
                                }
                            });
                    })
                    .catch(e => reject(e));
            }

            this._getGraphApiToken().then(graphToken => {
                authRequest(
                    `${this._configService.ApiUrl}/${this._configService.ConfigCode}/graphauth`,
                    graphToken
                ).then(
                    (hash: string) => resolveHash(hash),
                    () => tryAppAuth()
                );
            }).catch(() => {
                tryAppAuth();
            })
        });
    };

    public SPAuthenticate = () => {
        let promise = new Promise((resolve, reject) => {
            const spToken = this.IdentityToken;
            if (spToken && spToken.length > 0) {
                resolve();
            } else {
                this._getAuthToken()
                    .then(authenticateResult => {
                        
                        Cookies.set(this.IdentityCookieKey,
                            JSON.stringify({
                                token: authenticateResult.Jwt,                                
                            }),
                        {
                            expires: authenticateResult.ExpiresOn,
                            sameSite: "None",
                            secure: true
                        });
                        resolve();
                    })
                    .catch(e => handleError(e, reject));
            }
        });
        
        return promise;
    };

    public IdentityAuthenticate = () => {
        return new Promise((resolve, reject) => {
            const identityToken = this.IdentityToken;
            if (identityToken && identityToken.length > 0) {
                resolve();
            } else {
                reject();
            }
        });
    };

    public IdentitySignIn = (email: string, aCode: string) => {
        return new Promise((resolve, reject) => {
            const code = (aCode ? aCode : '').trim();
            const requestParams = {
                Email: email,
                Code: code,
                WidgetUrl: window.location.href
            };

            $.ajax({
                type: "POST",
                url: `${this._configService.ApiUrl}/${this._configService.ConfigCode}/token`,
                data: JSON.stringify(requestParams),
                contentType: "application/json",
                success: response => {
                    const date = new Date();
                    date.setDate(date.getDate() + 1);

                    const cookieContent = JSON.stringify({token: response});
                    let options = { expires: date };
                    if (location.protocol === 'https:') {
                        options = Object.assign(options, {
                            sameSite: "None",
                            secure: true
                        })
                    }

                    Cookies.set(
                        this.IdentityCookieKey,
                        cookieContent,
                        options
                    );
                    resolve();
                },
                error: xhr => {
                    const message =
                        xhr.responseJSON && xhr.responseJSON.error_description
                            ? xhr.responseJSON.error_description
                            : "Sign in failed";
                    reject(message);
                }
            }); 
        });
    };

    public IdentitySendCode = (
        name: string,
        email: string,
        captchaResponse: string
    ) => {
        return new Promise(async (resolve, reject) => {
            const requestParams = {
                Email: email,
                Name: name
            };
            $.ajax({
                type: "POST",
                url: `${this._configService.ApiUrl}/${this._configService.ConfigCode}/account/login?g-recaptcha-response=${captchaResponse}`,
                data: JSON.stringify(requestParams),
                contentType: "application/json",
                success: response => resolve(response),
                error: xhr => handleError(xhr, reject)
            });            
        });
    };

    public ResetPassword = (
        code: string,
        password: string,
        confirmPassword: string,
        captchaResponse: string
    ) => {
        return new Promise(async (resolve, reject) => {
            const requestParams = {
                Code: code.trim(),
                Password: password,
                ConfirmPassword: confirmPassword
            };
            $.ajax({
                type: "POST",
                url: `${this._configService.ApiUrl}/${this._configService.ConfigCode}/account/password?g-recaptcha-response=${captchaResponse}`,
                data: JSON.stringify(requestParams),
                contentType: "application/json",
                success: () => resolve(),
                error: xhr => handleError(xhr, reject)
            });
        });
    };

    public SignOut = () => {
        Cookies.remove(this.IdentityCookieKey);
    };
}



// WEBPACK FOOTER //
// ./Widget/services/AuthService.ts